import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const salesProductGrossProfitWidget: DashboardWidgetConfiguration = {
  widgetId: 'sales.product-gross-profit', name: 'Gross profit by product',
  description: 'Top 50 positive gross profits from posted Sales-linked invoices/credit notes less posted delivery/customer-return COGS in the selected accounting period, in organisation base currency. Excludes tax, overheads, POS-only sales and unposted operations; requires Finance Reporting permission.',
  apps: ['sales'], template: 'report',
  query: {kind: 'single', query: {
    version: 1, source: 'finance.sales-product-gross-profit', ...period(30),
    select: [
      {type: 'field', field: 'product_name', as: 'product_name'},
      {type: 'field', field: 'currency', as: 'currency'},
      {type: 'aggregate', function: 'sum', field: 'gross_profit', as: 'gross_profit'},
    ],
    group_by: [{field: 'product_id'}, {field: 'product_name'}, {field: 'currency'}],
    having: {type: 'condition', expression: {type: 'aggregate', function: 'sum', field: 'gross_profit'}, operator: 'gt', value: 0},
    order_by: [{ref: 'gross_profit', direction: 'desc'}, {ref: 'product_name', direction: 'asc'}], limit: 50,
  }},
  inputs: {title: 'Gross profit by product', subtitle: 'Top 50 · posted Sales invoice revenue less delivery cost',
    output: 'category_series', visualization: 'treemap', icon: 'money', showTimeControls: true,
    colors: ['#206bc4', '#087f5b', '#9c4a00', '#b02525', '#862e9c'], emptyText: 'No positive posted Sales gross profit for this period.'},
  dummyData: {value: 'Gross profit', series: [50, 30, 20, 12, 8]},
  limits: {minWidth: 6, maxWidth: 12, minHeight: 4, maxHeight: 8, defaultWidth: 6, defaultHeight: 5},
};
